export enum ReleaseTypeEnum {
  ALBUM = 1,
  SINGLE = 2,
  EP = 3,
}
